import { RecentlyViewed } from './recently-viewed-products.js';

// Componente para mostrar productos vistos recientemente
class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    const productHandle = this.dataset.productHandle;
    
    // Limpiar IDs numéricos antiguos del localStorage
    this.cleanOldData();
    
    // Guardar producto actual
    if (productHandle && productHandle !== '') {
      RecentlyViewed.addProduct(productHandle);
    }
    
    // Cargar y mostrar productos vistos
    this.loadRecentlyViewed();
  }
  
  cleanOldData() {
    const products = RecentlyViewed.getProducts();
    // Filtrar solo handles válidos (que no sean IDs numéricos)
    const validHandles = products.filter(handle => isNaN(handle));
    
    if (validHandles.length !== products.length) {
      // Si había IDs numéricos, limpiar y guardar solo los válidos
      localStorage.setItem('viewedProducts', JSON.stringify(validHandles));
      console.log('Datos antiguos limpiados. Productos válidos:', validHandles);
    }
  }
  
  async loadRecentlyViewed() {
    const productHandles = RecentlyViewed.getProducts();
    const currentProductHandle = this.dataset.productHandle;
    const maxProducts = parseInt(this.dataset.maxProducts || '4');
    
    console.log('Productos vistos recientemente:', productHandles);
    
    // Filtrar IDs numéricos antiguos (solo mantener handles válidos)
    // NO filtramos el producto actual aquí para tener más productos disponibles
    const validHandles = productHandles
      .filter(handle => isNaN(handle)); // Filtrar IDs numéricos (solo aceptar handles con letras)
    
    // Ahora sí, filtrar el producto actual y tomar los primeros N
    const filteredHandles = validHandles
      .filter(handle => handle !== currentProductHandle) // No mostrar el producto actual
      .slice(0, maxProducts);
    
    console.log('Productos a mostrar:', filteredHandles);
    
    if (filteredHandles.length === 0) {
      console.log('No hay productos para mostrar. Visita más páginas de productos para verlos aquí.');
      this.style.display = 'none';
      return;
    }
    
    // Obtener datos de productos
    const products = await this.fetchProducts(filteredHandles);
    
    console.log('Productos obtenidos:', products.length, products);
    
    if (products.length === 0) {
      console.log('No se pudieron cargar los productos. Verifica que los handles sean correctos.');
      this.style.display = 'none';
      return;
    }
    
    console.log('Renderizando productos vistos recientemente...');
    
    // Renderizar
    this.renderProducts(products);
  }
  
  async fetchProducts(productHandles) {
    const products = [];
    for (const handle of productHandles) {
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (response.ok) {
          products.push(await response.json());
        }
      } catch (error) {
        console.warn(`Error loading product ${handle}:`, error);
      }
    }
    return products;
  }
  
  renderProducts(products) {
    const container = this.querySelector('[data-recently-viewed-container]');
    
    if (!container) {
      console.warn('No se encontró el contenedor de productos recientemente vistos');
      this.style.display = 'none';
      return;
    }
    
    container.innerHTML = '';
    
    products.forEach(product => {
      const card = this.createProductCard(product);
      container.appendChild(card);
    });
  }
  
  createProductCard(product) {
    const item = document.createElement('div');
    item.className = 'resource-list__item';
    
    const link = document.createElement('a');
    link.href = `/products/${product.handle}`;
    link.style.textDecoration = 'none';
    link.style.color = 'inherit';
    
    const img = document.createElement('img');
    const imageUrl = product.featured_image || (product.images && product.images.length > 0 ? product.images[0] : '');
    img.src = imageUrl;
    img.alt = product.title || '';
    img.loading = 'lazy';
    img.style.width = '100%';
    img.style.aspectRatio = '3 / 4';
    img.style.objectFit = 'cover';
    img.style.borderRadius = '4px';
    
    const title = document.createElement('h3');
    title.textContent = product.title;
    title.style.marginTop = '8px';
    title.style.marginBottom = '4px';
    title.style.fontSize = 'var(--title-font-size, 14px)';
    title.style.fontWeight = '400';
    title.style.lineHeight = '1.3';
    title.style.textAlign = 'center';
    
    const priceContainer = document.createElement('div');
    priceContainer.style.marginTop = '4px';
    priceContainer.style.display = 'flex';
    priceContainer.style.gap = '8px';
    priceContainer.style.alignItems = 'center';
    priceContainer.style.justifyContent = 'center';
    
    // Precio actual
    const price = document.createElement('span');
    price.textContent = this.formatPrice(product.price);
    price.style.fontSize = 'var(--price-font-size, 16px)';
    price.style.fontWeight = '600';
    
    // Si el producto está en oferta, mostrar precio anterior
    if (product.compare_at_price && product.compare_at_price > product.price) {
      const comparePrice = document.createElement('span');
      comparePrice.textContent = this.formatPrice(product.compare_at_price);
      comparePrice.style.fontSize = 'var(--compare-price-font-size, 14px)';
      comparePrice.style.textDecoration = 'line-through';
      comparePrice.style.color = '#ff0000';
      
      priceContainer.appendChild(price);
      priceContainer.appendChild(comparePrice);
    } else {
      priceContainer.appendChild(price);
    }
    
    link.appendChild(img);
    link.appendChild(title);
    link.appendChild(priceContainer);
    item.appendChild(link);
    
    return item;
  }
  
  formatPrice(cents) {
    const price = cents / 100;
    return '$' + new Intl.NumberFormat('es-CO', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(price);
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);

